import { COMMON_PERMISSIONS, composePermissions } from '@/commons/permissoesGrupos';

export default [
    // Lista de Instrumentos Jurídicos
    {
        path: '/instrumentosjuridicos',
        name: 'listaInstrumentosJuridicos',
        component: () => import('@/modules/crci/views/listas/ListaInstrumentoJuridicoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('PROJETO', 'CRCI')],
            isRotaOrigem: true,
        },
    },
    // Detalhe de Instrumento Jurídico
    {
        path: '/instrumentojuridico/:id',
        name: 'detalheInstrumentoJuridico',
        component: () => import('@/modules/crci/views/detalhes/DetalheInstrumentoJuridicoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
]